import React, { Component } from 'react';
import { Modal, Input, Spin, Switch, Button, Radio } from 'antd';
import { inject, observer } from "mobx-react";
import Contract from "./Contract";
import "./index.scss";

const { TextArea } = Input;

@inject('store')
@observer
class index extends Component {
    state = {
        isSeal: 1
    }
    render() {
        const { visible, onOk, onCancel, data, onChange, loading } = this.props.store.applycontract;
        const { isSeal } = this.state;
        const isAdmin = (JSON.parse(sessionStorage.getItem('user') || "{}")['email']) === 'admin';
        return (
            <Modal
                title="申请合同"
                visible={visible}
                onCancel={onCancel}
                className="apply-billing"
                footer={[
                    <Button key="back" onClick={onCancel}>
                        取消
                    </Button>,
                    <Button
                        type="primary"
                        loading={loading}
                        onClick={() => onOk(isSeal)}
                    >
                        申请合同
                    </Button>,
                ]}
            >
                <Spin tip="合同申请发送中，请稍后..." spinning={loading}>
                    {!loading && (<div>
                        <p className="order-no">订单编号：{data.out_trade_no}</p>
                        <p >请填写合同接收信息</p>
                        <Radio.Group
                            className="select-type"
                            size="large"
                            value={isSeal} buttonStyle="solid" onChange={e => {
                                this.setState({ isSeal: e.target.value })
                            }}>
                            <Radio.Button value={1}>电子合同</Radio.Button>
                            <Radio.Button value={2}>纸质合同</Radio.Button>
                        </Radio.Group>
                        <p>
                            <span className="billing-name">合同甲方:</span>
                            <Input
                                placeholder="请输入单位名称"
                                value={data.hotel_name}
                                onChange={e => onChange('hotel_name', e.target.value)}
                            />
                        </p>
                        <p>
                            <span className="billing-name">公司联系人:</span>
                            <Input
                                placeholder="请输入联系人姓名"
                                value={data.billing_name}
                                onChange={e => onChange('billing_name', e.target.value)}
                            />
                        </p>
                        <p>
                            <span className="billing-name">公司电话:</span>
                            <Input
                                placeholder="请输入联系人电话"
                                value={data.billing_tel}
                                onChange={e => onChange('billing_tel', e.target.value)}
                            />
                        </p>
                        <p>
                            <span className="billing-name">公司地址:</span>
                            <TextArea
                                placeholder="请输入地址"
                                rows={2}
                                value={data.billing_addr}
                                onChange={e => onChange('billing_addr', e.target.value)}
                            />
                        </p>
                        {isAdmin && <p>
                            <span className="billing-name">合同金额:</span>
                            <Input
                                placeholder="合同金额"
                                value={data.money}
                                onChange={e => onChange('money', e.target.value)}
                            />
                        </p>}
                        {isAdmin && <p>
                            <span className="billing-name">合同日期:</span>
                            <Input
                                placeholder="合同日期"
                                value={data.add_time}
                                onChange={e => onChange('add_time', e.target.value)}
                            />
                        </p>}
                        {isAdmin && <p>
                            <span className="billing-name">开始时间:</span>
                            <Input
                                placeholder="开始时间"
                                value={data.current_time}
                                onChange={e => onChange('current_time', e.target.value)}
                            />
                        </p>}
                        {isAdmin && <p>
                            <span className="billing-name">结束时间:</span>
                            <Input
                                placeholder="结束时间"
                                value={data.expire_date}
                                onChange={e => onChange('expire_date', e.target.value)}
                            />
                        </p>}
                        {isSeal == 2 && <p>
                            <span className="billing-name">收件人姓名:</span>
                            <Input
                                placeholder="收件人姓名"
                                value={data.name}
                                onChange={e => onChange('name', e.target.value)}
                            />
                        </p>}
                        {isSeal == 2 && <p>
                            <span className="billing-name">收件人电话:</span>
                            <Input
                                placeholder="收件人电话"
                                value={data.tel}
                                onChange={e => onChange('tel', e.target.value)}
                            />
                        </p>}
                        {isSeal == 2 && <p>
                            <span className="billing-name">收件地址:</span>
                            <TextArea
                                placeholder="收件地址"
                                rows={2}
                                value={data.addr}
                                onChange={e => onChange('addr', e.target.value)}
                            />
                        </p>}
                        <p>
                            <span className="billing-name">邮箱:</span>
                            <Input
                                placeholder="请输入合同接收邮箱"
                                value={data.email}
                                onChange={e => onChange('email', e.target.value)}
                            />
                        </p>
                        {
                            isAdmin && <p>
                                <span className="billing-name">印章:</span>
                                <Switch
                                    checkedChildren="是"
                                    unCheckedChildren="否"
                                    checked={this.state.isSeal == 1}
                                    onChange={checked => {
                                        this.setState({ isSeal: checked ? 1 : 2 });
                                    }}
                                    style={{
                                        marginLeft: 20,
                                        marginTop: 5
                                    }}
                                />
                            </p>
                        }
                    </div>)}
                    {
                        loading && <Contract data={data} isSeal={this.state.isSeal == 1} />
                    }

                </Spin>
            </Modal>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/user/ApplicationContract/index.js